class ViewSectionRenderer {
  constructor($container) {
    this.$container = $container;
    this.url = this.$container.data("viewSectionUrl");
    if (!this.url) { return; }

    this.totalCount = +this.$container.data("viewCollectionTotalCount");
    this.count = this.countItems();
    if (this.count >= this.totalCount) { return; }

    this.setup();
    this.render();
  }

  setup() {
    if (this.totalCount > this.count) {
      this.$container.append(`\
<div class="view-section-read-more-container">
  <a href="#" class="btn btn-primary btn-lg view-section-read-more">${I18n.t("base.see_more")} &raquo;</a>
</div>\
`);
    }

    return this.$container.on("click", ".view-section-read-more", event => {
      event.preventDefault();
      return this.loadMore();
    }
    );
  }

  render() {
    let $button = this.$container.find(".view-section-read-more");

    $button.toggleClass("disabled", !!this.isLoading);
    $button.html(this.isLoading ? `${I18n.t("base.loading")} ...` : `${I18n.t("base.see_more")} &raquo;`);

    return $button.toggle(this.count < this.totalCount);
  }

  loadMore() {
    this.isLoading = true;
    this.render();

    return $.get(`${this.url}?offset=${this.count}`)
    .then(data => {
      this.isLoading = false;

      let newDomItems = $(data).find(".view-section-items").html();
      this.$container.find(".view-section-items").append(newDomItems);
      this.count = this.countItems();

      return this.render();
    }
    , () => {
      this.isLoading = false;
      return this.render();
    }
    );
  }

  countItems() {
    return this.$container.find(".view-section-items").children(".view-section-item").length;
  }
}


$(document).ready(() =>
  $(".view_mode-cards_listing, .view_mode-extended_cards_listing").each(function() {
    let viewSection = new ViewSectionRenderer($(this));

    if (st.viewSections == null) { st.viewSections = []; }
    return st.viewSections.push(viewSection);
  })
);



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/ViewSectionCollectionReadMore.js